export default __webpack_public_path__ + "UI/assets/media/star-5f435870.svg";